module.exports = __webpack_public_path__ + "static/bg3-90d64ef41b147bd1b0676227cf807d51.jpg";